module.exports = __webpack_public_path__ + "static/img/ci.29e78d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-aa/ci.png
// module id = x/xw
// module chunks = 0